import React, { useEffect, useState } from "react";

import heroBackground from "../../static/images/distant_bass_suite/hero-background.webp";

// A fixed UTC deadline keeps the launch identical for every visitor and refresh.
const LAUNCH_DATE = "2026-09-04T15:00:00Z";
const LAUNCH_TIME = Date.parse(LAUNCH_DATE);

const getRemainingTime = () => Math.max(0, LAUNCH_TIME - Date.now());

const LaunchCountdown: React.FC = ({ children }) => {
  const [remainingMs, setRemainingMs] = useState(getRemainingTime);
  const active = remainingMs > 0;

  useEffect(() => {
    if (!active) return;

    let timerId = 0;
    const update = () => {
      window.clearTimeout(timerId);
      const remaining = getRemainingTime();
      setRemainingMs(remaining);
      if (remaining > 0) {
        timerId = window.setTimeout(update, Math.min(1000, remaining));
      }
    };

    update();
    window.addEventListener("focus", update);
    document.addEventListener("visibilitychange", update);

    return () => {
      window.clearTimeout(timerId);
      window.removeEventListener("focus", update);
      document.removeEventListener("visibilitychange", update);
    };
  }, [active]);

  if (!active) return <>{children}</>;

  // Round up so the last fraction of a second never displays an expired timer.
  const secondsLeft = Math.ceil(remainingMs / 1000);
  const units = [
    { label: "Days", value: Math.floor(secondsLeft / 86400) },
    { label: "Hours", value: Math.floor((secondsLeft % 86400) / 3600) },
    { label: "Minutes", value: Math.floor((secondsLeft % 3600) / 60) },
    { label: "Seconds", value: secondsLeft % 60 },
  ];

  return (
    <section
      className="home-launch-countdown"
      aria-labelledby="home-launch-title"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.1) 0%, #000 95%), url(${heroBackground})`,
      }}
    >
      <h1 id="home-launch-title" className="sr-only">Countdown to launch</h1>
      <div className="home-launch-countdown__timer" role="timer" aria-label="Time until launch" aria-live="off">
        {units.map(({ label, value }) => (
          <div className="home-launch-countdown__unit" key={label}>
            <span className="home-launch-countdown__value">{String(value).padStart(2, "0")}</span>
            <span className="home-launch-countdown__label">{label}</span>
          </div>
        ))}
      </div>
      <time className="home-launch-countdown__date" dateTime={LAUNCH_DATE}>
        4 September 2026 &middot; 15:00 UTC
      </time>
    </section>
  );
};

export default LaunchCountdown;
